<template>
  <div
    :style="styleObject"
    class="skeleton-loader"
  />
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '1rem',
    },
    borderRadius: {
      type: String,
      default: null,
    },
    paddingBottom: {
      type: String,
      default: '0px',
    },
  },
  computed: {
    styleObject() {
      return {
        width: this.width,
        height: this.height,
        borderRadius: this.borderRadius,
        paddingBottom: this.paddingBottom,
      };
    },
  },
};
</script>
